import styled from 'styled-components';

import { lightGray, gray, exactWhite, black } from 'utils/style/colors';

interface IButtonGroupWrapper {
  width?: string;
  backgroundColor?: string;
  border?: boolean;
}
interface IStyledProps {
  selectedBackgroundColor?: string;
  backgroundColor?: string;
  selectedTextColor?: string;
  textColor?: string;
  isActive: boolean;
  flexBasis?: number;
  withoutPadding?: boolean;
  disabled?: boolean;
  border?: boolean;
}

export const ButtonGroupWrapper = styled('div')<IButtonGroupWrapper>`
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || `${exactWhite}`};
  //border: 1px solid ${lightGray};
  overflow: hidden;
  width: ${(props) => (props.width ? props.width : '100%')};
  border: ${(props) => props.border && `1px solid ${black}`};
`;

export const ButtonSpan = styled('div')<IStyledProps>`
  flex: ${(props) =>
    props.flexBasis ? `1 1 ${props.flexBasis}%` : '1 1 auto'};
  cursor: ${(props) =>
    props.disabled ? 'not-allowed' : props.isActive ? 'auto' : 'pointer'};
  color: ${(props) =>
    props.disabled
      ? gray
      : props.isActive
        ? props.selectedTextColor || `${exactWhite}`
        : props.textColor || `${black}`};
  background-color: ${(props) =>
    props.isActive && (props.selectedBackgroundColor ?? `${black}`)};
  text-align: center;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${(props) => (props.border ? '0.1rem' : '0.5rem')};
  margin: ${(props) => (props.border ? '0' : '0.5rem')};
  font-weight: ${(props) => (props.isActive ? '500' : '400')};
  line-height: 28px;
  padding: ${(props) => (props.withoutPadding ? 'auto 0' : '0 0.5rem')};
  vertical-align: middle;
  font-size: 0.8rem;
  &:hover {
    color: ${(props) =>
      props.disabled
        ? gray
        : props.isActive
          ? props.selectedTextColor || `${exactWhite}`
          : (props.selectedBackgroundColor ?? `${black}`)};
  }
  //&:focus {
  //  background-color: whitesmoke;
  //}
  & > input {
    max-width: 45px;
    height: 100% !important;
    padding: 1rem 0.5rem 0 !important;
    border: none !important;
    margin-bottom: 1rem !important;
  }
`;
